module.exports = __webpack_public_path__ + "static/img/6.815afec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/sp/6.png
// module id = xJ2y
// module chunks = 0